const deployURL = "https://financecrawlerbackend.onrender.com";
// const deployURL = "http://localhost:8000"
export default deployURL;